import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

const DragBar = props => {
  const dragSource = useRef(null)

  const attributeRef = useRef()
  attributeRef.current = { attribute: props.attribute, section: props.section, target: props.target }

  const onDragRef = useRef()
  onDragRef.current = props.onDrag

  if (null == dragSource.current) {
    dragSource.current = ADND.sources
      .draggableData({
        type: 'attribute',
        parent: 1,
        child: 1,
        lockX: true,
        dragLayerClassName: `PRAYTMTheme ${props.className}-source`
      })
      .fetchData(() => attributeRef.current)
      .onStart(() => {
        if (onDragRef.current) {
          onDragRef.current({ action: 'start', data: attributeRef.current })
        }
      })
      .onEnd(() => {
        if (onDragRef.current) {
          onDragRef.current({ action: 'end', data: attributeRef.current })
        }
      })
  }

  return (
    <div
      className={props.className}
      ref={node => void dragSource.current.connect(node)}
      onClick={event => event.stopPropagation()}
    >
      <i className={`icon-aytmfd-hotdog ${props.className}-icon`} />
    </div>
  )
}

DragBar.propTypes = {
  className: PropTypes.string,
  attribute: PropTypes.string,
  section: PropTypes.string,
  target: PropTypes.string,
  onDrag: PropTypes.func
}

export default DragBar
